/**
 * THIS FILE IS AUTOGENERATED. DO NOT EDIT.
 * To regenerate these files after changing A/B test configs, run this command:
 * `npm run generate-ab-tests`
 */

import {
  __abTest_base,
  __useAbTest_base,
  __inWinnerHoldout_base,
} from 'js/ab_tests/ab_test';

export const TEST_CONFIG = {
  active: false,
  finished: true,
  alternatives: [
    'control',
    'corpus_search',
    'reading_scent',
    'download_shelf',
    'cliffhanger_abstract',
    'one_paper_landing',
    'start_here_highlights',
    'empty_profile_field_desk',
    'profile_masthead',
    'phone_profile_hub',
    'end_of_profile',
    'field_launchpad_rail',
  ],
  winner: 'control',
} as const;

/**
 * Synchronously returns the variant for this A/B test:
 * autotest_logged_in_profile_visitor_2026_q3_v2
 *
 * Returns the bucket based on the current logged-in user id.
 * This function also makes a call to the server to bucket
 * the user server-side, but does not return the response.
 *
 * Once a user is bucketed, their variant for the test
 * is stored in `sessionStorage`, which we check to avoid
 * making duplicate bucketing calls to the server.
 * `sessionStorage` is cleared when the user closes their tab.
 */
export function abTest() {
  return __abTest_base(
    'autotest_logged_in_profile_visitor_2026_q3_v2',
    TEST_CONFIG,
  );
}

/**
 * React hook to return the bucket for this A/B test:
 * autotest_logged_in_profile_visitor_2026_q3_v2
 *
 * Returns the bucket based on the current logged-in user id.
 * Asynchronously records the test on the backend.
 */
export function useAbTest() {
  return __useAbTest_base(
    'autotest_logged_in_profile_visitor_2026_q3_v2',
    TEST_CONFIG,
  );
}

/**
 * Returns whether the user is in the winner holdout for this A/B test:
 * autotest_logged_in_profile_visitor_2026_q3_v2
 *
 * Returns true if all of the following are true:
 * - The test is finished
 * - The user is in the overall holdout
 * - The user is in the winner sub-holdout
 */
export function inWinnerHoldout() {
  return __inWinnerHoldout_base(
    'autotest_logged_in_profile_visitor_2026_q3_v2',
    TEST_CONFIG,
  );
}

// MD5 hash of test's YAML config; modification will fail commit hook
// 884d70b29187eb97b3682d510ca3b2cf
